import eventBus from "../eventBus";
import { Box } from "@chakra-ui/layout";
import React from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";	
import { timeFormat } from "d3-time-format";

import { ChartCanvas, Chart, ZoomButtons } from "react-stockcharts";

import { XAxis, YAxis } from "react-stockcharts/lib/axes";
import { fitWidth } from "react-stockcharts/lib/helper";

import {
	CrossHairCursor,
	CurrentCoordinate,
	MouseCoordinateX,
	MouseCoordinateY,
	EdgeIndicator,

} from "react-stockcharts/lib/coordinates";



import { CandlestickSeries,BarSeries,LineSeries,MACDSeries, RSISeries,
	    AreaSeries,RenkoSeries, KagiSeries, PointAndFigureSeries,
		StochasticSeries,
		StraightLine,
		AlternatingFillAreaSeries,ElderRaySeries,
		BollingerSeries, SARSeries, 
	    VolumeProfileSeries, } from "react-stockcharts/lib/series";

import { last, toObject } from "react-stockcharts/lib/utils";
import { discontinuousTimeScaleProvider } from "react-stockcharts/lib/scale";



import { TrendLine,FibonacciRetracement,EquidistantChannel, 
	 GannFan, StandardDeviationChannel, DrawingObjectSelector,
	 InteractiveText,  InteractiveYCoordinate } from "react-stockcharts/lib/interactive";



import {
	OHLCTooltip,
	MovingAverageTooltip,
	SingleValueTooltip,
	MACDTooltip,
	RSITooltip,
	StochasticTooltip,
	BollingerBandTooltip
} from "react-stockcharts/lib/tooltip";

import {
	saveInteractiveNodes,
	getInteractiveNodes,
} from "./interactiveutils";



import { getMorePropsForChart } from "react-stockcharts/lib/interactive/utils";
import { head } from "react-stockcharts/lib/utils";


import { ema, wma, sma, tma, macd, heikinAshi,renko, kagi, pointAndFigure,rsi,atr,
	stochasticOscillator, forceIndex,
	change, elderRay,
	bollingerBand, sar } from "react-stockcharts/lib/indicator";

import ReactDOM from "react-dom";

import { Flex } from "@chakra-ui/layout";
import { Image } from "@chakra-ui/image";

import {
  Checkbox,
  Text,
  Collapse,
  VStack,
  FormControl,
  FormLabel,
} from '@chakra-ui/react';


import { Button, Select, Input, 
	 Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton } from '@chakra-ui/react';


import algo from "react-stockcharts/lib/algorithm";
import {
	Label,
	Annotate,
	SvgPathAnnotation,
	buyPath,
	sellPath,
} from "react-stockcharts/lib/annotation";
import glovar from "./glovar";


import ChartTpl from './ChartTpl';

import { isNotDefined, isDefined } from "react-stockcharts/lib/utils";
 


function generate() {
	return Math.floor(Math.random() * 100000001);
  }
  
  const shortid = {
	generate
  };


function round(number, precision = 0) {
	const d = Math.pow(10, precision);
	return Math.round(number * d) / d;
}





//const colorsModal = ['#FF5733', '#33FF7A', '#3380FF', '#FF33C9', '#FFC933']; // Lista de colores disponibles
const colorsModal = [
	'#FF5733', '#FFBD33', '#FF33C9', '#FF33A8', '#FF3381',
	'#33FF7A', '#33FFB3', '#33A9FF', '#3371FF', '#334BFF',
	'#33FFA8', '#33FF61', '#33B4FF', '#335DFF', '#3339FF',
	'#FF3388', '#FF3359', '#FFA833', '#FFE933', '#A1FF33',
	'#33E5FF', '#33FFD0', '#5A33FF', '#9D33FF', '#CC33FF'
  ];

  const bbStroke = {
	top: "#964B00",
	middle: "#000000",
	bottom: "#964B00",
};

const bbFill = "#4682B4";


//var showZoom=false;
var llistaClicked= [ false, false, false, false, false];
const ICON_FULL_SIZE_CHART=11;
const ICON_LENS_ID=10;
const ICON_DRAW_LINE=0;
const ICON_FIBO_LINE=1;
const ICON_CHANNEL_LINE=2;
const ICON_STDDEV_LINE=3;
const ICON_GANN_LINE=4;
const ICON_DRAW_TEXT=5;
const ICON_DRAW_LABEL=6;
const ICON_DRAW_ARROW_UP=7;
const ICON_DRAW_ARROW_DOWN=8;
const ICON_DELETE_ELEMENTS=9;

var isDailyData = true;
var mustRefreshIndicators=false;

const TYPE_CANDLESTICK=0, TYPE_HEIKIN_ASHI=1, TYPE_AREA_SERIES=2, TYPE_LINE_SERIES=3, TYPE_RENKO_SERIES=4, TYPE_KAGI_SERIES=5, TYPE_POINTFIGURE_SERIES=6;
const OFFSET_Y_CHART=60;


var offsetYchart=0;

InteractiveText.defaultProps = {
	
	defaultText: {
	  bgFill: "#EEEEEE",
	  bgOpacity: 1,
	  bgStrokeWidth: 1,
	  textFill: "#000000",
	  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
	  fontSize: 12,
	  fontStyle: "normal",
	  fontWeight: "550",
	  //text: ""
	  text:  '\u2191', 
	},
	hoverText: {
	  enable: true,
	  bgHeight: "auto",
	  bgWidth: "auto",
	  text: "Click to select object",
	  selectedText: ""
	},
	textList: []
  };


class Dialog extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			text: props.text,
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSave = this.handleSave.bind(this);
	}
	componentWillReceiveProps(nextProps) {
		this.setState({
			text: nextProps.text,
		});
	}
	handleChange(e) {
		this.setState({
			text: e.target.value
		});
	}
	handleSave() {
		
		this.props.onSave(this.state.text, this.props.chartId);

		//if(this.state.enableInteractiveText) 
		{
		  llistaClicked[ICON_DRAW_TEXT] = false;
		  
		 this.setState({
			enableInteractiveText: false,
			//textList_1
		 });
		}

		
	}
	render() {

		const {
			showModal,
			onClose,
		} = this.props;
		const { text } = this.state;

		return (
			<Modal isOpen={showModal} onClose={onClose} size="md">
			<ModalOverlay />
			<ModalContent>
			  <ModalHeader>Edit text</ModalHeader>
			  <ModalCloseButton />
			  <ModalBody>
				<FormControl>
				  <FormLabel>Text</FormLabel>
				
				  <Input ref={text} placeholder='First name' onChange={this.handleChange} />
				</FormControl>
			  </ModalBody>
			  <ModalFooter>
				<Button colorScheme="blue" onClick={this.handleSave}>
				  Save
				</Button>
				
			  </ModalFooter>
			</ModalContent>
		  </Modal>
		);
	}
}


class Dialog2 extends React.Component {
	constructor(props) {
		
		super(props);
		this.state = {
			alert: props.alert,
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleChange2 = this.handleChange2.bind(this);
		this.handleSave = this.handleSave.bind(this);
	}
	componentWillReceiveProps(nextProps) {
		this.setState({
			alert: nextProps.alert,
		});
	}

	handleChange2(e) {
		
		const { alert } = this.state;

		this.setState({
			alert: {
				...alert,
				text: (e.target.value),
			}
		});
	}

	handleChange(e) {
		
		const { alert } = this.state;

		
		this.setState({
			alert: {
				...alert,
				yValue: Number(e.target.value),
			}
		});
	}
	handleSave() {
		
		this.props.onSave(this.state.alert, this.props.chartId);

		{
			llistaClicked[ICON_DRAW_LABEL] = false;
			
		  this.setState({
			//enableInteractiveY: false,
			//textList_1
		  });
		}
	}
	
	render() {

		const {
			showModal,
			onClose,
		} = this.props;

		const { text } = this.state;
		const { alert } = this.state;

		if (!showModal) return null;

		return (
			<Modal isOpen={showModal} onClose={onClose} size="md">
			<ModalOverlay />
			<ModalContent>
			  <ModalHeader>Edit Alert</ModalHeader>
			  <ModalCloseButton />
			  <ModalBody>
				<FormControl>
				  <FormLabel>Text</FormLabel>
				  <Input  placeholder={alert.text} onChange={this.handleChange2} />
				  <Input type="number" placeholder={alert.yValue} onChange={this.handleChange} />
				</FormControl>
			  </ModalBody>
			  <ModalFooter>
				<Button colorScheme="blue" onClick={this.handleSave}>
				  Save
				</Button>
				
			  </ModalFooter>
			</ModalContent>
		  </Modal>
		);
	}
}



class AreaChart extends React.Component {

	

	saveInteractiveNodesLocal(type, chartId) {
		function _0x2ada(_0x288626,_0x78cab8){const _0x8e4f3e=_0x8e4f();return _0x2ada=function(_0x2ada5c,_0x46b740){_0x2ada5c=_0x2ada5c-0xf3;let _0x32ac24=_0x8e4f3e[_0x2ada5c];return _0x32ac24;},_0x2ada(_0x288626,_0x78cab8);}function _0x8e4f(){const _0x24d309=['23138lLkJqB','8571069KFxwBK','interactiveNodes','21ilknqS','2155956xQRUYt','1198320grslHN','492300BBznKz','6NnXRoA','1890584tYrnll','1978425auKhtc'];_0x8e4f=function(){return _0x24d309;};return _0x8e4f();}(function(_0x149bcf,_0x79f3db){const _0x841d36=_0x2ada,_0x770450=_0x149bcf();while(!![]){try{const _0x1aa354=-parseInt(_0x841d36(0xf6))/0x1*(parseInt(_0x841d36(0xf3))/0x2)+parseInt(_0x841d36(0xf5))/0x3+parseInt(_0x841d36(0xfb))/0x4+parseInt(_0x841d36(0xfc))/0x5+-parseInt(_0x841d36(0xfa))/0x6+parseInt(_0x841d36(0xf9))/0x7*(parseInt(_0x841d36(0xf4))/0x8)+-parseInt(_0x841d36(0xf7))/0x9;if(_0x1aa354===_0x79f3db)break;else _0x770450['push'](_0x770450['shift']());}catch(_0x3ab681){_0x770450['push'](_0x770450['shift']());}}}(_0x8e4f,0x5e17b));return _0xc809f4=>{const _0x45eb44=_0x2ada;isNotDefined(this[_0x45eb44(0xf8)])&&(this['interactiveNodes']={});const _0x4d550f=type+'_'+chartId;(isDefined(_0xc809f4)||isDefined(this[_0x45eb44(0xf8)][_0x4d550f]))&&(this[_0x45eb44(0xf8)]={...this['interactiveNodes'],[_0x4d550f]:{'type':type,'chartId':chartId,'node':_0xc809f4}});};
	
		
	}

	 


	constructor(props) {
		
		super(props);

		this.setStateselectedOption = this.setStateselectedOption.bind(this);
		this.setStatenewOptionNumber= this.setStatenewOptionNumber.bind(this);

		this.onDrawCompleteArrowDown = this.onDrawCompleteArrowDown.bind(this);
		this.handleChoosePositionArrowDown = this.handleChoosePositionArrowDown.bind(this);
		this.handleSelectionDown = this.handleSelectionDown.bind(this);

		this.onDrawCompleteArrowUp = this.onDrawCompleteArrowUp.bind(this);
		this.handleChoosePositionArrowUp = this.handleChoosePositionArrowUp.bind(this);
		this.handleSelectionUP = this.handleSelectionUP.bind(this);

		this.onDragComplete3 = this.onDragComplete3.bind(this);
		this.onDelete3 = this.onDelete3.bind(this);

		this.handleChoosePosition3 = this.handleChoosePosition3.bind(this);
		this.handleSelection3 = this.handleSelection3.bind(this);
		this.handleDoubleClickAlert3 = this.handleDoubleClickAlert3.bind(this);

		this.handleDialogClose3 = this.handleDialogClose3.bind(this);
		this.handleChangeAlert3 = this.handleChangeAlert3.bind(this);
		this.handleDeleteAlert3 = this.handleDeleteAlert3.bind(this);

		this.onDrawCompleteText = this.onDrawCompleteText.bind(this);
		this.handleChoosePosition = this.handleChoosePosition.bind(this);


		this.onDrawCompleteGann = this.onDrawCompleteGann.bind(this);

		this.onDrawCompleteStddev = this.onDrawCompleteStddev.bind(this);
		this.onDrawCompleteChannel = this.onDrawCompleteChannel.bind(this);



		this.onFibComplete = this.onFibComplete.bind(this);

		this.onFibComplete1 = this.onFibComplete1.bind(this);
		

		this.handleSelectionFib = this.handleSelectionFib.bind(this);
		
		this.saveCanvasNodeFib = this.saveCanvasNodeFib.bind(this);
	

	    this.resetYDomain = this.resetYDomain.bind(this);
		this.handleReset = this.handleReset.bind(this);

		this.saveNode = this.saveNode.bind(this);
		this.saveChartAsImage = this.saveChartAsImage.bind(this);
		

		this.onKeyPress = this.onKeyPress.bind(this);
		this.onDrawCompleteChart1 = this.onDrawCompleteChart1.bind(this);
		
		this.handleSelection = this.handleSelection.bind(this);
		this.handleSelection2 = this.handleSelection2.bind(this);

		this.saveInteractiveNodes = saveInteractiveNodes.bind(this);
        this.getInteractiveNodes = getInteractiveNodes.bind(this);
		this.saveInteractiveNodesLocal = this.saveInteractiveNodesLocal.bind(this);

		this.saveCanvasNode = this.saveCanvasNode.bind(this);

		this.handleDialogClose = this.handleDialogClose.bind(this);
		this.handleTextChange = this.handleTextChange.bind(this);


		this.state = {

			//miDialog: new Dialog,
			enableInteractiveY: false,
			yCoordinateList_1: [],
			yCoordinateList_3: [],
			showModalY: false,
			alertToEdit: {},

			enableArrowUp: false,
			arrowUpList_1: [],

			enableArrowDown: false,
			arrowDownList_1: [],

			enableInteractiveText: false,
			textList_1: [],
			textList_3: [],
			showModal: false,

			text: props.text,

			enableGann: false,
			fans: [],

			enableStddev: false,
			stddev_1:[],

			enableChannel: false,
			channels_1: [],

			enableFib: false,
			retracements_1: [],
			retracements_3: [],
	  
			enableTrendLine: false,
			trends_1: [],
			trends_3: [],

      		indicators: [],
	  		scaleIndicator: 'daily',
      		selectedIndicator: 'ema',
      		selectedPeriod: 10,
	  		selectedColor: this.getRandomColor(),//'#FF0000', // Color por defecto
	

			  
			maOptions: [],
			candleTypeChart: 0, //candlestick by default
			isModalOpen: false,
			isModalEdit: false,
			editIndicatorIndex: -1,
			selectedOption: '',
			newOptionText: '',
			newOptionNumber: '',
			isOpenDropdown: false,


			CollapseIsOpen1: false,
            selectedOptions1: ['Volume'],

			CollapseIsOpen2: false,
            selectedOptions2: `${process.env.PUBLIC_URL}/assets/iconcandlestick.png`,

			refreshButtons:true,
			showZoom:false,
			showingFullSize:false,
			
		};
	}


	setStateselectedOption(targetValue) {
		
		this.setState({ selectedOption: targetValue, /*selectedOption: ''*/ })
	}

	setStatenewOptionNumber(targetValue) {
		
		this.setState({ newOptionNumber: targetValue, /*selectedOption: ''*/ })
	}

	handleSelection3(interactives, moreProps, e) {



		function _0x4548(){const _0x3eac1f=['handleSelectionUP','558jTpuyx','2612812VOwWSU','enableInteractiveY','yCoordinateList_','13138470sNzzUJ','chartId','state','enableInteractiveText','defaultPriceCoordinate','enableArrowDown','2iTLcqv','handleChoosePosition3','21472efDgSA','InteractiveYCoordinate','handleSelection2','2131094CXtlUj','2421UpBjrN','invert','generate','filter','length','902820VuWCoh','defaultProps','326874jmNRXp','10405MGzeyD','currentCharts'];_0x4548=function(){return _0x3eac1f;};return _0x4548();}function _0x498f(_0x3a1643,_0x51d65d){const _0x4548d8=_0x4548();return _0x498f=function(_0x498fc8,_0x2453c9){_0x498fc8=_0x498fc8-0x16c;let _0x574bde=_0x4548d8[_0x498fc8];return _0x574bde;},_0x498f(_0x3a1643,_0x51d65d);}const _0x49a14a=_0x498f;(function(_0x388068,_0x4fd09a){const _0x455659=_0x498f,_0x33f08f=_0x388068();while(!![]){try{const _0x5ef43e=-parseInt(_0x455659(0x185))/0x1+-parseInt(_0x455659(0x17a))/0x2*(parseInt(_0x455659(0x16c))/0x3)+-parseInt(_0x455659(0x171))/0x4+-parseInt(_0x455659(0x16d))/0x5*(parseInt(_0x455659(0x170))/0x6)+parseInt(_0x455659(0x17f))/0x7+parseInt(_0x455659(0x17c))/0x8*(parseInt(_0x455659(0x180))/0x9)+parseInt(_0x455659(0x174))/0xa;if(_0x5ef43e===_0x4fd09a)break;else _0x33f08f['push'](_0x33f08f['shift']());}catch(_0x37e015){_0x33f08f['push'](_0x33f08f['shift']());}}}(_0x4548,0x759eb));if(this[_0x49a14a(0x176)][_0x49a14a(0x179)])this['handleSelectionDown'](interactives,moreProps,e);else{if(this[_0x49a14a(0x176)]['enableArrowUp'])this[_0x49a14a(0x16f)](interactives,moreProps,e);else{if(this['state'][_0x49a14a(0x177)])this[_0x49a14a(0x17e)](interactives,moreProps,e);else{if(this[_0x49a14a(0x176)][_0x49a14a(0x172)]){const independentCharts=moreProps[_0x49a14a(0x16e)][_0x49a14a(0x183)](_0x1b0442=>_0x1b0442!==0x2);if(independentCharts[_0x49a14a(0x184)]>0x0){const first=head(independentCharts),morePropsForChart=getMorePropsForChart(moreProps,first),{mouseXY:[,mouseY],chartConfig:{yScale}}=morePropsForChart,yValue=round(yScale[_0x49a14a(0x181)](mouseY),0x2),newAlert={...InteractiveYCoordinate[_0x49a14a(0x186)][_0x49a14a(0x178)],'yValue':yValue,'id':shortid[_0x49a14a(0x182)]()};this[_0x49a14a(0x17b)](newAlert,morePropsForChart,e);}}else{if(interactives[0x6]['type']===_0x49a14a(0x17d)){const state=toObject([interactives[0x6]],_0x3340e5=>{const _0x117f18=_0x49a14a;return[_0x117f18(0x173)+_0x3340e5[_0x117f18(0x175)],_0x3340e5['objects']];});this['setState'](state);}}}}}
	}

	handleChoosePosition3(alert, moreProps) {
		const { id: chartId } = moreProps.chartConfig;
		
		this.setState({
			[`yCoordinateList_${chartId}`]: [
				...this.state[`yCoordinateList_${chartId}`],
				alert
			],
			enableInteractiveY: false,
		});

		//pq al tornar del modal ja s'haurà pintat
		llistaClicked[ICON_DRAW_LABEL] = false;
		
	}

	handleDoubleClickAlert3(item) {

		//console.log("handleDoubleClickAlert3:"+JSON.stringify(item))
		this.setState({
			showModal3: true,
			alertToEdit: {
				alert: item.object,
				enableInteractiveY:true,
				chartId: item.chartId,
			},
		});
	}

	handleChangeAlert3(alert, chartId) {

		chartId=1;
		const yCoordinateList = this.state[`yCoordinateList_${chartId}`];
		const newAlertList = yCoordinateList.map(d => {
			return d.id === alert.id ? alert : d;
		});

		
		this.setState({
			[`yCoordinateList_${chartId}`]: newAlertList,
			showModal3: false,
			enableInteractiveY: false,
		});
	}
	
	handleDeleteAlert3() {
		const { alertToEdit } = this.state;
		const key = `yCoordinateList_${alertToEdit.chartId}`;
		const yCoordinateList = this.state[key].filter(d => {
			return d.id !== alertToEdit.alert.id;
		});
		this.setState({
			showModal3: false,
			alertToEdit: {},
			[key]: yCoordinateList
		});
	}

	handleDialogClose3() {
		// cancel alert edit
		this.setState(state => {
			const { originalAlertList, alertToEdit } = state;
			const key = `yCoordinateList_${alertToEdit.chartId}`;
			const list = originalAlertList || state[key];

			return {
				showModal3: false,
				[key]: list,
			};
		});
	}


	onDelete3(yCoordinate, moreProps) {
		this.setState(state => {
			const chartId = moreProps.chartConfig.id;
			const key = `yCoordinateList_${chartId}`;

			const list = state[key];
			return {
				[key]: list.filter(d => d.id !== yCoordinate.id)
			};
		});
	}


	

	onDragComplete3(yCoordinateList, moreProps, draggedAlert) {

		//console.log("ON DRAG COMPLETE3!!")
		llistaClicked[ICON_DRAW_LABEL] = false;
		this.canvasNode.cancelDrag();

		// this gets called on drag complete of drawing object
		const { id: chartId } = moreProps.chartConfig;

		const key = `yCoordinateList_${chartId}`;
		const alertDragged = draggedAlert != null;

		this.setState({
			enableInteractiveY: false,
			[key]: yCoordinateList,
			showModal3: alertDragged,
			alertToEdit: {
				alert: draggedAlert,
				chartId,
			},
			originalAlertList: this.state[key],
		});
	}


	handleChange(e) {
		this.setState({
			text: e.target.value
		});
	}


	handleSave() {
		this.props.onSave(this.state.text, this.props.chartId);
	}


	saveCanvasNodeFib(node) {
		//console.log("Ejecuto saveCanvasNode!!")
		this.canvasNode = node;
		//console.log("Ejecuto node:"+node)
	}

	handleSelectionFib(interactives) {
		const state = toObject(interactives, each => {
			return [
				`retracements_${each.chartId}`,
				each.objects,
			];
		});
		this.setState(state);
	}

	onDrawCompleteChart1(trends_1) {
	
		llistaClicked[ICON_DRAW_LINE] = false;

		this.canvasNode.cancelDrag();

		this.setState({
			trends_1,
			enableTrendLine: false,
			
		});
	}

	onFibComplete() {
		this.refs.fib.terminate();
		
		this.setState({
			enableFib: false
		})
	}

	onFibComplete1(retracements_1) {
		
		llistaClicked[ICON_FIBO_LINE] = false;

		this.canvasNode.cancelDrag();
        //this.node_1.terminate();

		this.setState({
			retracements_1,
			enableFib: false
		});
	}

	

	onDrawCompleteText(textList_1) {
		
		//console.log("ondrawCompleteText")
		llistaClicked[ICON_DRAW_TEXT] = false;

		this.canvasNode.cancelDrag();

		this.setState({
			enableInteractiveText: false,
			textList_1
		});
	}

	
	onDrawCompleteArrowUp(arrowUpList_1) {
		
		
		llistaClicked[ICON_DRAW_ARROW_UP] = false;

		this.canvasNode.cancelDrag();

		this.setState({
			enableArrowUp: false,
			arrowUpList_1
		});
		
	}

	onDrawCompleteArrowDown(arrowDownList_1) {
		
		llistaClicked[ICON_DRAW_ARROW_DOWN] = false;

		this.canvasNode.cancelDrag();

		this.setState({
			enableArrowDown: false,
			arrowDownList_1
			
		});
	}

	

	onDrawCompleteChannel(channels_1) {
		
	
		llistaClicked[ICON_CHANNEL_LINE] = false;

		this.canvasNode.cancelDrag();
       

		this.setState({
			enableChannel: false,
			channels_1
		});
	}

	onDrawCompleteGann(fans) {
		
		
		llistaClicked[ICON_GANN_LINE] = false;

		this.canvasNode.cancelDrag();
       

		this.setState({
			enableGann: false,
			fans
		});
	}

	onDrawCompleteStddev(stddev_1) {
		
		
		
		llistaClicked[ICON_STDDEV_LINE] = false;

		this.canvasNode.cancelDrag();
        

		this.setState({
			enableStddev: false,
			stddev_1
		});

		
	}

	

	updateIndicatorPeriods = (data) => {
			
		const { indicators, scaleIndicator } = this.state;	
		const scaleFactor = scaleIndicator === 'weekly' ? 5 : 1;

		
			var _0x20ebf2=_0x1b6f;(function(_0x5c3b64,_0x3dd55e){var _0x4dc233=_0x1b6f,_0x4f33f0=_0x5c3b64();while(!![]){try{var _0x9e9f8f=parseInt(_0x4dc233(0x15a))/0x1*(-parseInt(_0x4dc233(0x150))/0x2)+-parseInt(_0x4dc233(0x155))/0x3*(-parseInt(_0x4dc233(0x14a))/0x4)+parseInt(_0x4dc233(0x14c))/0x5+-parseInt(_0x4dc233(0x14d))/0x6*(-parseInt(_0x4dc233(0x159))/0x7)+-parseInt(_0x4dc233(0x151))/0x8*(parseInt(_0x4dc233(0x15b))/0x9)+parseInt(_0x4dc233(0x158))/0xa+-parseInt(_0x4dc233(0x160))/0xb*(-parseInt(_0x4dc233(0x157))/0xc);if(_0x9e9f8f===_0x3dd55e)break;else _0x4f33f0['push'](_0x4f33f0['shift']());}catch(_0xeac521){_0x4f33f0['push'](_0x4f33f0['shift']());}}}(_0x482c,0x20deb));var NEWscaleIndicator='';scaleIndicator==_0x20ebf2(0x14b)?NEWscaleIndicator=_0x20ebf2(0x15f):NEWscaleIndicator='weekly';function _0x1b6f(_0x347bf3,_0x2cc6d2){var _0x482cd2=_0x482c();return _0x1b6f=function(_0x1b6fe7,_0x1a20fd){_0x1b6fe7=_0x1b6fe7-0x148;var _0x18d094=_0x482cd2[_0x1b6fe7];return _0x18d094;},_0x1b6f(_0x347bf3,_0x2cc6d2);}function _0x482c(){var _0x407034=['44wjNOuO','weekly','146265VKxDgX','918XPJLbx','ema','wma','832SreKDF','57656TJLjTu','tma','options','merge','31089HGNcTx','map','564GNZGsQ','2119990kGgrDl','11396mctBOG','511Mytbud','333JgijEY','type','color','accessor','daily','2233eRGIlg','setState','sma'];_0x482c=function(){return _0x407034;};return _0x482c();}const updatedIndicators=indicators[_0x20ebf2(0x156)](_0x50cfd8=>{var _0x5005e5=_0x20ebf2,_0x3ca73a=_0x50cfd8[_0x5005e5(0x153)]()['windowSize'],_0x3721dd=_0x50cfd8['options']()[_0x5005e5(0x15c)],_0x894d20=_0x50cfd8[_0x5005e5(0x153)]()[_0x5005e5(0x15d)];const _0x10bb24=parseInt(_0x3ca73a,0xa),_0x468484=_0x3721dd;let _0x4e03da;if(_0x468484==='ema')_0x4e03da=ema()[_0x5005e5(0x153)]({'windowSize':_0x10bb24,'type':_0x468484,'color':_0x894d20})[_0x5005e5(0x154)]((_0x52b9d5,_0x467055)=>{var _0x1cee0e=_0x5005e5;_0x52b9d5[_0x1cee0e(0x14e)+_0x10bb24]=_0x467055;})[_0x5005e5(0x15e)](_0x4d6264=>_0x4d6264[_0x5005e5(0x14e)+_0x10bb24])(data);else{if(_0x468484===_0x5005e5(0x149))_0x4e03da=sma()[_0x5005e5(0x153)]({'windowSize':_0x10bb24,'type':_0x468484,'color':_0x894d20})[_0x5005e5(0x154)]((_0x2f8174,_0x5602d1)=>{_0x2f8174['sma'+_0x10bb24]=_0x5602d1;})[_0x5005e5(0x15e)](_0x231739=>_0x231739[_0x5005e5(0x149)+_0x10bb24])(data);else{if(_0x468484===_0x5005e5(0x152))_0x4e03da=tma()[_0x5005e5(0x153)]({'windowSize':_0x10bb24,'type':_0x468484,'color':_0x894d20})[_0x5005e5(0x154)]((_0x4f1a46,_0x171b08)=>{var _0x4cef08=_0x5005e5;_0x4f1a46[_0x4cef08(0x152)+_0x10bb24]=_0x171b08;})[_0x5005e5(0x15e)](_0x1485c4=>_0x1485c4[_0x5005e5(0x152)+_0x10bb24])(data);else _0x468484===_0x5005e5(0x14f)&&(_0x4e03da=wma()[_0x5005e5(0x153)]({'windowSize':_0x10bb24,'type':_0x468484,'color':_0x894d20})[_0x5005e5(0x154)]((_0x11e3f3,_0x21f81d)=>{var _0x3024e5=_0x5005e5;_0x11e3f3[_0x3024e5(0x14f)+_0x10bb24]=_0x21f81d;})[_0x5005e5(0x15e)](_0x389b06=>_0x389b06[_0x5005e5(0x14f)+_0x10bb24])(data));}}const _0x1bdbb4=_0x4e03da;return _0x1bdbb4;});this[_0x20ebf2(0x148)]({'indicators':updatedIndicators,'scaleIndicator':NEWscaleIndicator});
			
		  };





	getRandomColor = () => {
		return colorsModal[(Math.floor(Math.random() * colorsModal.length))];
	  };

	handleColorChange = event => {
		const color = event.target.value;
		this.setState({ selectedColor: color });
	  };

;

  
	addIndicator = (/*selectedPeriod*/) => {
		
	
		const { newOptionNumber,selectedOption,selectedColor} = this.state;
	
		const selectedPeriod=parseInt(newOptionNumber, 10);
		const selectedIndicator=selectedOption;
		
		//newOptionNumber
	
		
		
		  function _0x25f8(){const _0x424099=['merge','841772lxMTBo','774756VjdkzD','57251LNHdvA','accessor','ema','setState','14cXDSpU','3409344bvAiQd','850680CnNTsm','10JUHIXE','options','sma','380569BpfhiB','wma','6WKMlrb','1765425gdyZJc','tma','indicators'];_0x25f8=function(){return _0x424099;};return _0x25f8();}function _0x4f8f(_0x2efd11,_0x295aef){const _0x25f8da=_0x25f8();return _0x4f8f=function(_0x4f8ff4,_0x478634){_0x4f8ff4=_0x4f8ff4-0x6e;let _0x1c1577=_0x25f8da[_0x4f8ff4];return _0x1c1577;},_0x4f8f(_0x2efd11,_0x295aef);}const _0xc670f8=_0x4f8f;(function(_0x28674f,_0x2c3693){const _0x2f5972=_0x4f8f,_0x1456d3=_0x28674f();while(!![]){try{const _0x48120c=parseInt(_0x2f5972(0x80))/0x1*(parseInt(_0x2f5972(0x71))/0x2)+parseInt(_0x2f5972(0x73))/0x3+-parseInt(_0x2f5972(0x7e))/0x4+parseInt(_0x2f5972(0x7a))/0x5+-parseInt(_0x2f5972(0x79))/0x6*(parseInt(_0x2f5972(0x77))/0x7)+-parseInt(_0x2f5972(0x72))/0x8+-parseInt(_0x2f5972(0x7f))/0x9*(parseInt(_0x2f5972(0x74))/0xa);if(_0x48120c===_0x2c3693)break;else _0x1456d3['push'](_0x1456d3['shift']());}catch(_0x2be821){_0x1456d3['push'](_0x1456d3['shift']());}}}(_0x25f8,0x3f8f4));let indicatorFunction;if(selectedIndicator===_0xc670f8(0x6f))indicatorFunction=ema()[_0xc670f8(0x75)]({'windowSize':selectedPeriod,'type':selectedIndicator,'color':selectedColor})[_0xc670f8(0x7d)]((_0x3b4a0d,_0x29bef5)=>{const _0x5a5272=_0xc670f8;_0x3b4a0d[_0x5a5272(0x6f)+selectedPeriod]=_0x29bef5;})[_0xc670f8(0x6e)](_0x43484c=>_0x43484c['ema'+selectedPeriod]);else{if(selectedIndicator===_0xc670f8(0x76))indicatorFunction=sma()[_0xc670f8(0x75)]({'windowSize':selectedPeriod,'type':selectedIndicator,'color':selectedColor})[_0xc670f8(0x7d)]((_0x32f3a6,_0x56a916)=>{const _0x12da93=_0xc670f8;_0x32f3a6[_0x12da93(0x76)+selectedPeriod]=_0x56a916;})[_0xc670f8(0x6e)](_0x3c08ad=>_0x3c08ad[_0xc670f8(0x76)+selectedPeriod]);else{if(selectedIndicator===_0xc670f8(0x7b))indicatorFunction=tma()['options']({'windowSize':selectedPeriod,'type':selectedIndicator,'color':selectedColor})[_0xc670f8(0x7d)]((_0x283a1f,_0xc019d8)=>{const _0x1065ca=_0xc670f8;_0x283a1f[_0x1065ca(0x7b)+selectedPeriod]=_0xc019d8;})[_0xc670f8(0x6e)](_0xe8d8cc=>_0xe8d8cc[_0xc670f8(0x7b)+selectedPeriod]);else selectedIndicator==='wma'&&(indicatorFunction=wma()[_0xc670f8(0x75)]({'windowSize':selectedPeriod,'type':selectedIndicator,'color':selectedColor})[_0xc670f8(0x7d)]((_0x4970f7,_0x2465e9)=>{const _0x226fa0=_0xc670f8;_0x4970f7[_0x226fa0(0x78)+selectedPeriod]=_0x2465e9;})['accessor'](_0xfb268b=>_0xfb268b['wma'+selectedPeriod]));}}this[_0xc670f8(0x70)](_0x5e0b8b=>({'indicators':[..._0x5e0b8b[_0xc670f8(0x7c)],indicatorFunction]}));
	  };

	 
	  editIndicator = (index) => {

		if(index>=0) {
		
		

		
		const { newOptionNumber,selectedOption,selectedColor} = this.state;
	
		

		const selectedPeriod=parseInt(newOptionNumber, 10);
		const selectedIndicator=selectedOption;
		
		
	
		let indicatorFunction;
		
		
	

		var _0xaa123b=_0x40a7;(function(_0x9de7a4,_0x212703){var _0x2a8be4=_0x40a7,_0x575d23=_0x9de7a4();while(!![]){try{var _0x12695e=parseInt(_0x2a8be4(0xc8))/0x1*(-parseInt(_0x2a8be4(0xc1))/0x2)+-parseInt(_0x2a8be4(0xbf))/0x3*(-parseInt(_0x2a8be4(0xcb))/0x4)+parseInt(_0x2a8be4(0xcc))/0x5+-parseInt(_0x2a8be4(0xcf))/0x6*(parseInt(_0x2a8be4(0xca))/0x7)+-parseInt(_0x2a8be4(0xce))/0x8+parseInt(_0x2a8be4(0xc0))/0x9*(parseInt(_0x2a8be4(0xc3))/0xa)+parseInt(_0x2a8be4(0xbd))/0xb*(-parseInt(_0x2a8be4(0xc2))/0xc);if(_0x12695e===_0x212703)break;else _0x575d23['push'](_0x575d23['shift']());}catch(_0x287d9f){_0x575d23['push'](_0x575d23['shift']());}}}(_0x5564,0x9b010));function _0x40a7(_0x39640b,_0x2322a3){var _0x5564b1=_0x5564();return _0x40a7=function(_0x40a77a,_0x46823a){_0x40a77a=_0x40a77a-0xbd;var _0x28b137=_0x5564b1[_0x40a77a];return _0x28b137;},_0x40a7(_0x39640b,_0x2322a3);}function _0x5564(){var _0x47abce=['1897NfjbHs','2477548mCAeIj','2897115MiCTBT','wma','6375856gAlTBZ','26868qQrbWs','1749RtzhIk','ema','6mLRsaA','258507gtGDxm','14xtUHhh','17508VLqwRh','430QuUbVL','merge','tma','options','accessor','25127KZYLOr','sma'];_0x5564=function(){return _0x47abce;};return _0x5564();}if(selectedIndicator===_0xaa123b(0xbe))indicatorFunction=ema()[_0xaa123b(0xc6)]({'windowSize':selectedPeriod,'type':selectedIndicator,'color':selectedColor})[_0xaa123b(0xc4)]((_0x54b74b,_0x1cc542)=>{_0x54b74b['ema'+selectedPeriod]=_0x1cc542;})[_0xaa123b(0xc7)](_0x3f0d04=>_0x3f0d04[_0xaa123b(0xbe)+selectedPeriod]);else{if(selectedIndicator==='sma')indicatorFunction=sma()[_0xaa123b(0xc6)]({'windowSize':selectedPeriod,'type':selectedIndicator,'color':selectedColor})['merge']((_0x295215,_0x394886)=>{var _0x2625ee=_0xaa123b;_0x295215[_0x2625ee(0xc9)+selectedPeriod]=_0x394886;})[_0xaa123b(0xc7)](_0x307de4=>_0x307de4[_0xaa123b(0xc9)+selectedPeriod]);else{if(selectedIndicator===_0xaa123b(0xc5))indicatorFunction=tma()[_0xaa123b(0xc6)]({'windowSize':selectedPeriod,'type':selectedIndicator,'color':selectedColor})['merge']((_0x4ab7b1,_0x25a6be)=>{var _0x5110ce=_0xaa123b;_0x4ab7b1[_0x5110ce(0xc5)+selectedPeriod]=_0x25a6be;})[_0xaa123b(0xc7)](_0x3b9a7f=>_0x3b9a7f['tma'+selectedPeriod]);else selectedIndicator==='wma'&&(indicatorFunction=wma()[_0xaa123b(0xc6)]({'windowSize':selectedPeriod,'type':selectedIndicator,'color':selectedColor})[_0xaa123b(0xc4)]((_0x3255dc,_0x275c83)=>{var _0x1d0188=_0xaa123b;_0x3255dc[_0x1d0188(0xcd)+selectedPeriod]=_0x275c83;})[_0xaa123b(0xc7)](_0x53a97f=>_0x53a97f[_0xaa123b(0xcd)+selectedPeriod]));}}

		  const newOption = `${selectedOption} ${selectedPeriod}`;
		  const updatedOptions = [...this.state.maOptions];
		  updatedOptions[index] = newOption;
		 
		  {
			const updatedIndicators = [...this.state.indicators];
			updatedIndicators[index] = indicatorFunction;
			this.setState(
				{ 
				  indicators: updatedIndicators,
				  maOptions: updatedOptions,
				  isModalOpen: false,
				  isModalEdit: false,
			      selectedOption: '',
			      newOptionText: '',
			      newOptionNumber: '',
				  editIndicatorIndex:-1,
				});
		  };
		  

		  
	

		}
	
	  };

	  

  


  removeIndicator = index => {

	
	{
	 this.setState(prevState => {
	  const updatedIndicators = prevState.indicators.filter((_, i) => i !== index);
	  return { indicators: updatedIndicators };
	 });
   }
  };

  



  handleIndicatorChange = (event) => {
    this.setState({ selectedIndicator: event.target.value });
  };

  handlePeriodChange = (event) => {
    this.setState({ selectedPeriod: parseInt(event.target.value, 10) });
  };

	
	handleOptionDelete = (index) => {
		const { maOptions } = this.state;
		const newOptions = maOptions.filter((_, i) => i !== index);
		this.setState({ maOptions: newOptions });

		this.removeIndicator(index);
	  };
	
	  handleModalOpen = () => {
		this.setState({
			selectedColor: this.getRandomColor(),
			editIndicatorIndex:-1,
			isModalOpen: true });
	  };
	
	  handleModalClose = () => {
		this.setState({
		  isModalOpen: false,
		  isModalEdit: false,
		  selectedOption: '',
		  newOptionText: '',
		  newOptionNumber: '',
		  editIndicatorIndex:-1
		});
	  };



	  handleModalEdit = (index) => {
		this.setState({
			selectedColor: this.state.indicators[index].options().color,
			newOptionNumber: this.state.indicators[index].options().windowSize,
			selectedOption: this.state.indicators[index].options().type,
			editIndicatorIndex:index,
			isModalEdit: true });
	  };

	
	  handleCreateOption = () => {
		
		const { newOptionText, newOptionNumber, maOptions, selectedOption } = this.state;
	

		if ((selectedOption || newOptionNumber)) {
		  //const newOptionValue = selectedOption || newOptionNumber;
		  const newOption = `${selectedOption} ${newOptionNumber}`;
	
		  this.addIndicator(newOptionNumber);
		  //console.log("new Option:"+newOption)

		  this.setState((prevState) => ({
			maOptions: [...prevState.maOptions, newOption],
			isModalOpen: false,
			selectedOption: '',
			newOptionText: '',
			newOptionNumber: '',
		  }));

		 
		  
		}
	  };
	
	  toggleDropdownMA = () => {
		this.setState((prevState) => ({
		  isOpenDropdown: !prevState.isOpenDropdown,
		}));
	  };

           

	toggleDropdown = () => {
		this.setState((prevState) => ({
			CollapseIsOpen1: !prevState.CollapseIsOpen1,
		}));
	  };
	
	  toggleOption = (option) => {
		this.setState((prevState) => {
		  const selectedOptions1 = prevState.selectedOptions1.includes(option)
			? prevState.selectedOptions1.filter((item) => item !== option)
			: [...prevState.selectedOptions1, option];
	
		  return {
			selectedOptions1,
		  };
		});
	  };

	  toggleDropdown2 = () => {
		this.setState((prevState) => ({
			CollapseIsOpen2: !prevState.CollapseIsOpen2,
		}));
	  };
	
	  selectOption2 = (option,index) => {

		
		this.setState({
			candleTypeChart: index,
			selectedOptions2: option,
			CollapseIsOpen2: false,
		});
	  };


	resetYDomain() {
		this.node.resetYDomain();
		
	}
	
	saveNode(node) {
		this.node = node;
	}
	


	saveCanvasNode(node) {
		this.canvasNode = node;
	}

	handleTextChange(text, chartId) {

		
		const textList = this.state[`textList_${chartId}`];
		const allButLast = textList
			.slice(0, textList.length - 1);

		const lastText = {
			...last(textList),
			text,
		};

		this.setState({
			[`textList_${chartId}`]: [
				...allButLast,
				lastText
			],
			showModal: false,
			enableInteractiveText: false,
		});
		
		this.componentDidMount();
	}
	handleDialogClose() {
		
		this.setState({
			showModal: false,
			enableInteractiveText: false,
		});
		this.componentDidMount();
	}

	componentDidMount() {
		document.addEventListener("keyup", this.onKeyPress);

		
	}
	componentWillUnmount() {
		document.removeEventListener("keyup", this.onKeyPress);		
	}

		componentWillMount() {
		this.setState({
			suffix: 1
		});
	}

	
	

	handleChoosePosition(text, moreProps) {
		this.componentWillUnmount();
		const { id: chartId } = moreProps.chartConfig;

		this.setState({
			[`textList_${chartId}`]: [
				...this.state[`textList_${chartId}`],
				text
			],
			showModal: true,
			text: text.text,
			chartId
		});

		//pq al tornar del modal ja s'haurà pintat
		llistaClicked[ICON_DRAW_TEXT] = false;
	}

	handleChoosePositionArrowUp(text, moreProps) {
		this.componentWillUnmount();
		const { id: chartId } = moreProps.chartConfig;

		this.setState({
			[`arrowUpList_${chartId}`]: [
				...this.state[`arrowUpList_${chartId}`],
				text
			],
			//showModal: true,
			enableArrowUp:false,
			text: text.text,
			chartId
		});

		//pq al tornar del modal ja s'haurà pintat
		llistaClicked[ICON_DRAW_ARROW_UP] = false;
	}

	handleChoosePositionArrowDown(text, moreProps) {
		this.componentWillUnmount();
		const { id: chartId } = moreProps.chartConfig;

		this.setState({
			[`arrowDownList_${chartId}`]: [
				...this.state[`arrowDownList_${chartId}`],
				text
			],
			//showModal: true,
			enableArrowDown:false,
			text: text.text,
			chartId
		});

		//pq al tornar del modal ja s'haurà pintat
		llistaClicked[ICON_DRAW_ARROW_DOWN] = false;
	}

	handleSelection2(interactives, moreProps, e) {

		

	  function _0x463e(){const _0x4642bf=['1856248xOPjQW','state','14KtdEBn','InteractiveText','enableInteractiveText','filter','handleSelection3','defaultProps','348HHeMgd','handleChoosePosition','2622579OMdGeB','7925928phglvV','length','2162660HZgJVM','9AgMAZQ','type','currentCharts','18mBsnKw','enableInteractiveY','defaultText','4711120slSJpu','153053FCosJi','textList_','49EWtGZn','244981lifbZU'];_0x463e=function(){return _0x4642bf;};return _0x463e();}const _0x39ed7f=_0x15d7;function _0x15d7(_0x1d00ca,_0x1b12f6){const _0x463e8d=_0x463e();return _0x15d7=function(_0x15d755,_0x4d280b){_0x15d755=_0x15d755-0x77;let _0x2948d6=_0x463e8d[_0x15d755];return _0x2948d6;},_0x15d7(_0x1d00ca,_0x1b12f6);}(function(_0x150b21,_0x39fb34){const _0x238bc5=_0x15d7,_0x1dc97b=_0x150b21();while(!![]){try{const _0x234794=-parseInt(_0x238bc5(0x78))/0x1*(parseInt(_0x238bc5(0x7e))/0x2)+parseInt(_0x238bc5(0x86))/0x3+parseInt(_0x238bc5(0x87))/0x4+parseInt(_0x238bc5(0x89))/0x5*(-parseInt(_0x238bc5(0x8d))/0x6)+-parseInt(_0x238bc5(0x7a))/0x7*(-parseInt(_0x238bc5(0x7c))/0x8)+-parseInt(_0x238bc5(0x8a))/0x9*(parseInt(_0x238bc5(0x77))/0xa)+-parseInt(_0x238bc5(0x7b))/0xb*(parseInt(_0x238bc5(0x84))/0xc);if(_0x234794===_0x39fb34)break;else _0x1dc97b['push'](_0x1dc97b['shift']());}catch(_0x974fee){_0x1dc97b['push'](_0x1dc97b['shift']());}}}(_0x463e,0xf2aa2));if(this[_0x39ed7f(0x7d)][_0x39ed7f(0x8e)])this[_0x39ed7f(0x82)](interactives,moreProps,e);else{if(this[_0x39ed7f(0x7d)][_0x39ed7f(0x80)]){const independentCharts=moreProps[_0x39ed7f(0x8c)][_0x39ed7f(0x81)](_0x4c5cad=>_0x4c5cad!==0x2);if(independentCharts[_0x39ed7f(0x88)]>0x0){const first=head(independentCharts),morePropsForChart=getMorePropsForChart(moreProps,first),{mouseXY:[,mouseY],chartConfig:{yScale},xAccessor,currentItem}=morePropsForChart,position=[xAccessor(currentItem),yScale['invert'](mouseY)],newText={...InteractiveText[_0x39ed7f(0x83)][_0x39ed7f(0x8f)],'position':position};this[_0x39ed7f(0x85)](newText,morePropsForChart,e);}}else{if(interactives[0x5][_0x39ed7f(0x8b)]===_0x39ed7f(0x7f)){const state=toObject([interactives[0x5]],_0xf4bcbf=>{const _0xf6f3d=_0x39ed7f;return[_0xf6f3d(0x79)+_0xf4bcbf['chartId'],_0xf4bcbf['objects']];});this['setState'](state);}}}
	}

	handleSelectionUP(interactives, moreProps, e) {

	

		function _0x5292(_0x491922,_0x59d628){const _0x1e5e3a=_0x1e5e();return _0x5292=function(_0x5292fe,_0x30ad85){_0x5292fe=_0x5292fe-0x92;let _0x495227=_0x1e5e3a[_0x5292fe];return _0x495227;},_0x5292(_0x491922,_0x59d628);}const _0x3b70c7=_0x5292;(function(_0xa01b7a,_0x14b4fe){const _0x32cb18=_0x5292,_0x57902e=_0xa01b7a();while(!![]){try{const _0x40f100=-parseInt(_0x32cb18(0x97))/0x1+parseInt(_0x32cb18(0x9e))/0x2*(parseInt(_0x32cb18(0xa7))/0x3)+parseInt(_0x32cb18(0x96))/0x4*(parseInt(_0x32cb18(0x95))/0x5)+parseInt(_0x32cb18(0x9f))/0x6+parseInt(_0x32cb18(0x9d))/0x7*(-parseInt(_0x32cb18(0xa5))/0x8)+-parseInt(_0x32cb18(0x92))/0x9*(parseInt(_0x32cb18(0x9b))/0xa)+-parseInt(_0x32cb18(0xa4))/0xb*(parseInt(_0x32cb18(0xa0))/0xc);if(_0x40f100===_0x14b4fe)break;else _0x57902e['push'](_0x57902e['shift']());}catch(_0x3c780e){_0x57902e['push'](_0x57902e['shift']());}}}(_0x1e5e,0xbf1f3));if(this[_0x3b70c7(0xa1)]['enableArrowUp']){const independentCharts=moreProps[_0x3b70c7(0x9a)][_0x3b70c7(0x99)](_0x34a05c=>_0x34a05c!==0x2);if(independentCharts[_0x3b70c7(0x94)]>0x0){const first=head(independentCharts),morePropsForChart=getMorePropsForChart(moreProps,first),{mouseXY:[,mouseY],chartConfig:{yScale},xAccessor,currentItem}=morePropsForChart,position=[xAccessor(currentItem),yScale[_0x3b70c7(0x98)](mouseY)],newText={...InteractiveText['defaultProps'][_0x3b70c7(0xa6)],'position':position};this['handleChoosePositionArrowUp'](newText,morePropsForChart,e);}}else{if(interactives[0x5][_0x3b70c7(0x93)]===_0x3b70c7(0xa2)){const state=toObject([interactives[0x5]],_0x123a52=>{const _0x7a0f0a=_0x3b70c7;return[_0x7a0f0a(0x9c)+_0x123a52[_0x7a0f0a(0xa3)],_0x123a52['objects']];});this['setState'](state);}}function _0x1e5e(){const _0x591391=['state','InteractiveText1','chartId','198RuOfQX','305432pdWOVm','defaultText','3000nJJodF','228213XObBWY','type','length','4085405dpgtfW','4zBiiEc','974304wrdAPN','invert','filter','currentCharts','110rRLHgi','arrowUpList_','105GEuNSm','2568qxqndi','5802396ratbSI','306264idLKKg'];_0x1e5e=function(){return _0x591391;};return _0x1e5e();}

	}


	handleSelectionDown(interactives, moreProps, e) {

		
       
		function _0x18a0(_0x51af89,_0x252de2){const _0x155d5f=_0x155d();return _0x18a0=function(_0x18a092,_0x35dbf6){_0x18a092=_0x18a092-0xd8;let _0x3c50eb=_0x155d5f[_0x18a092];return _0x3c50eb;},_0x18a0(_0x51af89,_0x252de2);}const _0x5072b3=_0x18a0;function _0x155d(){const _0x35d6ee=['1460556bWkmUF','currentCharts','87736yGXPRx','273YhRqel','filter','defaultProps','chartId','state','1610586WCabeI','140662jnmStU','objects','setState','1103779RMhdua','518754VoLbkJ','type','invert','length','2067263ilXNZt','25jcmANO','arrowDownList_','15VrxErT','handleChoosePositionArrowDown','10TjouIe'];_0x155d=function(){return _0x35d6ee;};return _0x155d();}(function(_0x3ff920,_0x58cc8e){const _0x1104b9=_0x18a0,_0x16cd3d=_0x3ff920();while(!![]){try{const _0x1b52b9=-parseInt(_0x1104b9(0xde))/0x1+-parseInt(_0x1104b9(0xdb))/0x2*(-parseInt(_0x1104b9(0xe6))/0x3)+parseInt(_0x1104b9(0xe9))/0x4+-parseInt(_0x1104b9(0xe4))/0x5*(-parseInt(_0x1104b9(0xdf))/0x6)+parseInt(_0x1104b9(0xec))/0x7*(parseInt(_0x1104b9(0xeb))/0x8)+parseInt(_0x1104b9(0xda))/0x9*(parseInt(_0x1104b9(0xe8))/0xa)+parseInt(_0x1104b9(0xe3))/0xb;if(_0x1b52b9===_0x58cc8e)break;else _0x16cd3d['push'](_0x16cd3d['shift']());}catch(_0x3b2bc5){_0x16cd3d['push'](_0x16cd3d['shift']());}}}(_0x155d,0xcd0e6));if(this[_0x5072b3(0xd9)]['enableArrowDown']){const independentCharts=moreProps[_0x5072b3(0xea)][_0x5072b3(0xed)](_0x105182=>_0x105182!==0x2);if(independentCharts[_0x5072b3(0xe2)]>0x0){const first=head(independentCharts),morePropsForChart=getMorePropsForChart(moreProps,first),{mouseXY:[,mouseY],chartConfig:{yScale},xAccessor,currentItem}=morePropsForChart,position=[xAccessor(currentItem),yScale[_0x5072b3(0xe1)](mouseY)],newText={...InteractiveText[_0x5072b3(0xee)]['defaultText'],'position':position};this[_0x5072b3(0xe7)](newText,morePropsForChart,e);}}else{if(interactives[0x5][_0x5072b3(0xe0)]==='InteractiveText1'){const state=toObject([interactives[0x5]],_0x2eac74=>{const _0x4a3837=_0x5072b3;return[_0x4a3837(0xe5)+_0x2eac74[_0x4a3837(0xd8)],_0x2eac74[_0x4a3837(0xdc)]];});this[_0x5072b3(0xdd)](state);}}

	}


	handleSelection(interactives) {
		

				
		function _0x3fa5(_0x477df3,_0x5440e6){const _0x3917d3=_0x3917();return _0x3fa5=function(_0x3fa501,_0xe5b802){_0x3fa501=_0x3fa501-0xd8;let _0xa3b2fa=_0x3917d3[_0x3fa501];return _0xa3b2fa;},_0x3fa5(_0x477df3,_0x5440e6);}const _0x5f141b=_0x3fa5;function _0x3917(){const _0x5071fa=['82345zytOCQ','type','fans','3461348JAglyo','414vYCkYP','textList_','InteractiveText','FibonacciRetracement','GannFan','88OvMjKE','453439lmnUwd','yCoordinateList_','7716fIRRyH','5018661YwoDWZ','chartId','220463NigtSx','StandardDeviationChannel','trends_','stddev_','21786430JBNRnA','retracements_','setState','objects','276JJHtQa','channels_'];_0x3917=function(){return _0x5071fa;};return _0x3917();}(function(_0x1f04dd,_0x48fd9f){const _0x42d852=_0x3fa5,_0x392709=_0x1f04dd();while(!![]){try{const _0x11b3f7=parseInt(_0x42d852(0xda))/0x1+-parseInt(_0x42d852(0xe8))/0x2*(parseInt(_0x42d852(0xf0))/0x3)+-parseInt(_0x42d852(0xe7))/0x4+-parseInt(_0x42d852(0xe4))/0x5*(-parseInt(_0x42d852(0xe2))/0x6)+parseInt(_0x42d852(0xee))/0x7*(-parseInt(_0x42d852(0xed))/0x8)+-parseInt(_0x42d852(0xd8))/0x9+parseInt(_0x42d852(0xde))/0xa;if(_0x11b3f7===_0x48fd9f)break;else _0x392709['push'](_0x392709['shift']());}catch(_0x334138){_0x392709['push'](_0x392709['shift']());}}}(_0x3917,0x7753b));if(interactives[0x0][_0x5f141b(0xe5)]==='Trendline'){const state=toObject([interactives[0x0]],_0x34e901=>{const _0x3a90cb=_0x5f141b;return[_0x3a90cb(0xdc)+_0x34e901[_0x3a90cb(0xd9)],_0x34e901[_0x3a90cb(0xe1)]];});this[_0x5f141b(0xe0)](state);}if(interactives[0x1][_0x5f141b(0xe5)]===_0x5f141b(0xeb)){const state=toObject([interactives[0x1]],_0x9bda74=>{const _0x4ecd8f=_0x5f141b;return[_0x4ecd8f(0xdf)+_0x9bda74['chartId'],_0x9bda74['objects']];});this['setState'](state);}if(interactives[0x2][_0x5f141b(0xe5)]==='EquidistantChannel'){const state=toObject([interactives[0x2]],_0x35fba1=>{const _0x782dec=_0x5f141b;return[_0x782dec(0xe3)+_0x35fba1[_0x782dec(0xd9)],_0x35fba1['objects']];});this[_0x5f141b(0xe0)](state);}if(interactives[0x3][_0x5f141b(0xe5)]===_0x5f141b(0xec)){const state=toObject([interactives[0x3]],_0x2af2bd=>{const _0x12b106=_0x5f141b;return[_0x12b106(0xe6),_0x2af2bd[_0x12b106(0xe1)]];});this['setState'](state);}if(interactives[0x4][_0x5f141b(0xe5)]===_0x5f141b(0xdb)){const state=toObject([interactives[0x4]],_0x442724=>{const _0x2f6c7a=_0x5f141b;return[_0x2f6c7a(0xdd)+_0x442724[_0x2f6c7a(0xd9)],_0x442724[_0x2f6c7a(0xe1)]];});this[_0x5f141b(0xe0)](state);}if(interactives[0x5][_0x5f141b(0xe5)]===_0x5f141b(0xea)){const state=toObject([interactives[0x5]],_0x397583=>{const _0x1a90d4=_0x5f141b;return[_0x1a90d4(0xe9)+_0x397583['chartId'],_0x397583[_0x1a90d4(0xe1)]];});this['setState'](state);}if(interactives[0x6][_0x5f141b(0xe5)]==='InteractiveYCoordinate'){const state=toObject([interactives[0x6]],_0x5c7abe=>{const _0xa50f97=_0x5f141b;return[_0xa50f97(0xef)+_0x5c7abe[_0xa50f97(0xd9)],_0x5c7abe['objects']];});this[_0x5f141b(0xe0)](state);}

	}
	
	
	onKeyPress(e) {
		const keyCode = e.which;
		//console.log(keyCode);
		switch (keyCode) {

		case 46: { // DEL


			//InteractiveText
			try { 
				const arrowUpList_1= this.state.arrowUpList_1
					.filter(each => !each.selected);
				
				this.canvasNode.cancelDrag();
				this.setState({
					arrowUpList_1,
				});
			}
			catch(Exx) {}

			try { 
			this.canvasNode.cancelDrag();
			this.setState({
				yCoordinateList_1: this.state.yCoordinateList_1.filter(d => !d.selected),
				//yCoordinateList_3: this.state.yCoordinateList_3.filter(d => !d.selected)
			});
		   }
		   catch(Exx) {}


			//InteractiveText
			try { 
				

				const textList_1= this.state.textList_1
					.filter(each => !each.selected);
				
				this.canvasNode.cancelDrag();
				this.setState({
					textList_1,
				});
			}
			catch(Exx) {}


            //FansGann
			try { 
				const fans = this.state.fans
					.filter(each => !each.selected);
				
				this.canvasNode.cancelDrag();
				this.setState({
					fans,
				});
			}
			catch(Exx) {}
			

			//STDdev
			try { 
				const stddev_1 = this.state.stddev_1
					.filter(each => !each.selected);
				
				this.canvasNode.cancelDrag();
				this.setState({
					stddev_1,
				});
			}
			catch(Exx) {}


			//Channels
			try { 
				const channels_1 = this.state.channels_1
					.filter(each => !each.selected);
				
				this.canvasNode.cancelDrag();
				this.setState({
					channels_1,
				});
			}
			catch(Exx) {}


            //Fibonacci
			try { // DEL
				const retracements_1 = this.state.retracements_1
					.filter(each => !each.selected);
				const retracements_3 = this.state.retracements_3
					.filter(each => !each.selected);
	
				this.canvasNode.cancelDrag();
				this.setState({
					retracements_1,
					retracements_3,
				});
			}
			catch(Exx) {}


			const trends_1 = this.state.trends_1
				.filter(each => !each.selected);
			const trends_3 = this.state.trends_3
				.filter(each => !each.selected);

			try { this.canvasNode.cancelDrag(); } catch(Exxx) {}
			this.setState({
				trends_1,
				trends_3,
			});
			break;
		}
		case 27: { // ESC
            try {
			this.canvasNode.cancelDrag();
			this.node_1.terminate();
			this.node_3.terminate();
			this.setState({
				enableFib: false
			});
		    }
            catch(Exx) {}

			this.node_1.terminate();
			this.node_3.terminate();
			try { this.canvasNode.cancelDrag();  } catch(Exxx) {}
			this.setState({
				enableTrendLine: false
			});
			break;
		}
		
		}
	}

	
	saveChartAsImage() {
		//console.log("entro en saveChart!")
		 // Obtén una colección de todos los elementos en el documento
		/* const elementos = document.querySelectorAll('*');

		 // Itera a través de la colección y muestra los nombres de los elementos
		 elementos.forEach(elemento => {
		   console.log(elemento.nodeName);
		 });*/

		var container = ReactDOM.findDOMNode(this.chart); // eslint-disable-line react/no-find-dom-node
		//console.log("encuentro container:"+container)
		//SaveChartAsImage.saveChartAsImage(container);
		//console.log("salgo en saveChart!")

	}

	handleReset() {
		this.setState({
			suffix: this.state.suffix + 1
		});
	}

	

	render() 
	{

		

			
function _0xc7bf(){const _0x5da30c=['options','low','45rYMvEs','7291530hWAHbK','atr14','9039EjvqXa','SHORT','ema30','merge','fullSTO','209TIFCNd','18HFkBVP','sma20','LONG','macd','247415skeaIW','283510tuZNFn','fiEMA13','accessor','high','stroke','rsi','Go\x20short','blue','ema10','788dSITTU','ema50','ema20','longShort','474250DQldmp','1166344AknukG','11798vBRQbl','#FF0000','sar'];_0xc7bf=function(){return _0x5da30c;};return _0xc7bf();}function _0x3954(_0x3b2d10,_0x1cc569){const _0xc7bf08=_0xc7bf();return _0x3954=function(_0x3954ca,_0x52e68f){_0x3954ca=_0x3954ca-0xe9;let _0x1c995c=_0xc7bf08[_0x3954ca];return _0x1c995c;},_0x3954(_0x3b2d10,_0x1cc569);}const _0x406e0d=_0x3954;(function(_0x2d02f6,_0x16fca7){const _0x506598=_0x3954,_0x184474=_0x2d02f6();while(!![]){try{const _0x5ea09e=-parseInt(_0x506598(0xec))/0x1*(parseInt(_0x506598(0x109))/0x2)+parseInt(_0x506598(0xef))/0x3*(-parseInt(_0x506598(0x103))/0x4)+-parseInt(_0x506598(0xf9))/0x5*(-parseInt(_0x506598(0xf5))/0x6)+parseInt(_0x506598(0x107))/0x7+-parseInt(_0x506598(0x108))/0x8+parseInt(_0x506598(0xed))/0x9+-parseInt(_0x506598(0xfa))/0xa*(-parseInt(_0x506598(0xf4))/0xb);if(_0x5ea09e===_0x16fca7)break;else _0x184474['push'](_0x184474['shift']());}catch(_0x264042){_0x184474['push'](_0x184474['shift']());}}}(_0xc7bf,0x88c65));const ema20=ema()['id'](0x0)['options']({'windowSize':0xd})[_0x406e0d(0xf2)]((_0x260c9c,_0x13b37f)=>{_0x260c9c['ema20']=_0x13b37f;})['accessor'](_0x8be08c=>_0x8be08c[_0x406e0d(0x105)]),ema50=ema()[_0x406e0d(0xea)]({'windowSize':0x32})[_0x406e0d(0xf2)]((_0xe870fd,_0x5eefc6)=>{const _0x39ba8a=_0x406e0d;_0xe870fd[_0x39ba8a(0x104)]=_0x5eefc6;})['accessor'](_0x5a9eee=>_0x5a9eee[_0x406e0d(0x104)]),buySell=algo()['windowSize'](0x2)['accumulator'](([_0x13b5f6,_0x1cea9b])=>{const _0x5a77bc=_0x406e0d,{ema20:_0xc8ffe1,ema50:_0x572c4c}=_0x13b5f6,{ema20:_0x145d1a,ema50:_0x332880}=_0x1cea9b;if(_0xc8ffe1<_0x572c4c&&_0x145d1a>_0x332880)return _0x5a77bc(0xf7);if(_0xc8ffe1>_0x572c4c&&_0x145d1a<_0x332880)return _0x5a77bc(0xf0);})[_0x406e0d(0xf2)]((_0x53a6fb,_0x8fda8e)=>{const _0x54d250=_0x406e0d;_0x53a6fb[_0x54d250(0x106)]=_0x8fda8e;}),defaultAnnotationProps={},longAnnotationProps={...defaultAnnotationProps,'y':({yScale:_0x331296,datum:_0x1b2393})=>_0x331296(_0x1b2393[_0x406e0d(0xeb)]),'fill':'#006517','path':buyPath,'tooltip':'Go\x20long'},shortAnnotationProps={...defaultAnnotationProps,'y':({yScale:_0x593edf,datum:_0x1e367f})=>_0x593edf(_0x1e367f[_0x406e0d(0xfd)]),'fill':_0x406e0d(0x10a),'path':sellPath,'tooltip':_0x406e0d(0x100)},accelerationFactor=0.02,maxAccelerationFactor=0.2,defaultSar=sar()[_0x406e0d(0xea)]({'accelerationFactor':accelerationFactor,'maxAccelerationFactor':maxAccelerationFactor})[_0x406e0d(0xf2)]((_0x54ce43,_0x7eff50)=>{_0x54ce43['sar']=_0x7eff50;})[_0x406e0d(0xfc)](_0x2dbd24=>_0x2dbd24[_0x406e0d(0xe9)]),bb=bollingerBand()[_0x406e0d(0xf2)]((_0x483b3b,_0x583f87)=>{_0x483b3b['bb']=_0x583f87;})['accessor'](_0x66124a=>_0x66124a['bb']),elder=elderRay(),changeCalculator=change(),fi=forceIndex()[_0x406e0d(0xf2)]((_0xa0bfaf,_0x4567e3)=>{_0xa0bfaf['fi']=_0x4567e3;})[_0x406e0d(0xfc)](_0x4f5f0e=>_0x4f5f0e['fi']),fiEMA13=ema()['id'](0x1)[_0x406e0d(0xea)]({'windowSize':0xd,'sourcePath':'fi'})['merge']((_0x3dd85f,_0xcce5d8)=>{const _0x44d116=_0x406e0d;_0x3dd85f[_0x44d116(0xfb)]=_0xcce5d8;})[_0x406e0d(0xfc)](_0x8fe455=>_0x8fe455[_0x406e0d(0xfb)]),heikinAshiIndicator=heikinAshi(),renkoIndicator=renko(),kagiIndicator=kagi(),pointAndFigureIndicator=pointAndFigure(),fullSTO=stochasticOscillator()[_0x406e0d(0xea)]({'windowSize':0xe,'kWindowSize':0x3,'dWindowSize':0x4})[_0x406e0d(0xf2)]((_0x2979fa,_0x34a141)=>{const _0x2dfcc1=_0x406e0d;_0x2979fa[_0x2dfcc1(0xf3)]=_0x34a141;})['accessor'](_0x2cb353=>_0x2cb353[_0x406e0d(0xf3)]),rsiCalculator=rsi()[_0x406e0d(0xea)]({'windowSize':0xe})[_0x406e0d(0xf2)]((_0x36e0d8,_0x2d9171)=>{const _0x29da11=_0x406e0d;_0x36e0d8[_0x29da11(0xff)]=_0x2d9171;})[_0x406e0d(0xfc)](_0x47af8c=>_0x47af8c['rsi']),atr14=atr()[_0x406e0d(0xea)]({'windowSize':0xe})[_0x406e0d(0xf2)]((_0x2e99b3,_0x184fa8)=>{const _0x4cabcc=_0x406e0d;_0x2e99b3[_0x4cabcc(0xee)]=_0x184fa8;})[_0x406e0d(0xfc)](_0x4e8478=>_0x4e8478[_0x406e0d(0xee)]),macdCalculator=macd()[_0x406e0d(0xea)]({'fast':0xc,'slow':0x1a,'signal':0x9})['merge']((_0x471981,_0x37ea8c)=>{const _0x14265a=_0x406e0d;_0x471981[_0x14265a(0xf8)]=_0x37ea8c;})['accessor'](_0x19c6b8=>_0x19c6b8[_0x406e0d(0xf8)]),ema30=ema()[_0x406e0d(0xea)]({'windowSize':0x1e,'sourcePath':'close'})['skipUndefined'](!![])['merge']((_0x53a24c,_0x3bb69d)=>{_0x53a24c['ema30']=_0x3bb69d;})[_0x406e0d(0xfc)](_0x3e2287=>_0x3e2287[_0x406e0d(0xf1)])[_0x406e0d(0xfe)](_0x406e0d(0x101)),sma20=sma()['options']({'windowSize':0x14})[_0x406e0d(0xf2)]((_0x178679,_0x1d4d17)=>{_0x178679['sma20']=_0x1d4d17;})[_0x406e0d(0xfc)](_0x20b8ab=>_0x20b8ab[_0x406e0d(0xf6)]),ema10=ema()[_0x406e0d(0xea)]({'windowSize':0xa})[_0x406e0d(0xf2)]((_0x1c361e,_0x635f8a)=>{const _0x18561c=_0x406e0d;_0x1c361e[_0x18561c(0x102)]=_0x635f8a;})[_0x406e0d(0xfc)](_0x3764c0=>_0x3764c0['ema10']);


		try {
		//const { data, type, width, ratio,colorLine } = this.props;
		//if(data.length<2) { return null; }

		
		const createWeeklyData = (data) => {
			const weeklyData = [];
			let currentWeekData = null;
			let currentWeekNumber = -1;
		  
			data.forEach((dailyDatum) => {
			  const currentDate = new Date(dailyDatum.date);
			  const weekNumber = getWeekNumber(currentDate);
			  //console.log("weekNumber:"+weekNumber)
		  
			  if (currentWeekNumber !== weekNumber) {
				if (currentWeekData) {
					//console.log("currentWeekData:"+JSON.stringify(currentWeekData))
				  weeklyData.push(currentWeekData);
				}
				currentWeekData = { week: weekNumber, ...dailyDatum };
				currentWeekNumber = weekNumber;
			  } else {
				currentWeekData.high = Math.max(currentWeekData.high, dailyDatum.high);
				currentWeekData.low = Math.min(currentWeekData.low, dailyDatum.low);
				currentWeekData.close = dailyDatum.close;
			  }
			});
		  
			//console.log("llego al final!!")
			if (currentWeekData) {
			  weeklyData.push(currentWeekData);
			}
		  
			//console.log("llego al final 2!!")
			return weeklyData;
		  };
		  
		  const getWeekNumber = (date) => {
			const onejan = new Date(date.getFullYear(), 0, 1);
			return Math.ceil((((date - onejan) / 86400000) + onejan.getDay() + 1) / 7);
		  };

		
		const { type, data: initialData0, width, ratio, labelChart,ticker,fullsizeChart } = this.props;
		const { mouseMoveEvent, panEvent, zoomEvent, zoomAnchor } = this.props;

		var initialData=[];
		var OFFSET_CANDLES=100;

		var OFFSET_Y_FULLSCREEN=0;

		if(fullsizeChart==1) {
		 OFFSET_Y_FULLSCREEN=glovar.OFFSET_Y_FULLSCREEN_CHART;
		 //console.log(`INI OFFSET_Y_FULLSCREEN: ${OFFSET_Y_FULLSCREEN}`);
		 const dpi = window.devicePixelRatio;
		 if(dpi>1) {
		 OFFSET_Y_FULLSCREEN=OFFSET_Y_FULLSCREEN/dpi;
		 }
		 else if(dpi==1) { 
			OFFSET_Y_FULLSCREEN=(OFFSET_Y_FULLSCREEN*1.75);
		 }
		 else if(dpi<1) { 
			OFFSET_Y_FULLSCREEN=(OFFSET_Y_FULLSCREEN*2);
		 }
        //console.log(`La densidad de píxeles es: ${dpi}`);
		//console.log(`OFFSET_Y_FULLSCREEN: ${OFFSET_Y_FULLSCREEN}`);

		}


		if(!isDailyData) {
			//console.log("antes initial")
			initialData=createWeeklyData(initialData0);
			OFFSET_CANDLES=40;
			//console.log("initialData switched!")
		}
		else {
			initialData=initialData0;
		}

		if(mustRefreshIndicators) {
           this.updateIndicatorPeriods(initialData);
		}


		//const calculatedData = ema30(sma20(wma20(tma20(ema50(	smaVolume50(initialData))))));
        //const calculatedData = ema30(sma20(((ema50((initialData))))));


		const { indicators, candleTypeChart } = this.state;
		const { CollapseIsOpen1, selectedOptions1 } = this.state;

		
   



	  var calculatedData = indicators.reduce((acc, indicatorFunction) => {
		return indicatorFunction(acc);
	  }, initialData);

	  if(candleTypeChart==TYPE_HEIKIN_ASHI) {
		calculatedData = heikinAshiIndicator(calculatedData);
	  }

	  if(candleTypeChart==TYPE_RENKO_SERIES) {
		calculatedData = renkoIndicator(calculatedData);
	  }

	  if(candleTypeChart==TYPE_KAGI_SERIES) {
		calculatedData = kagiIndicator(calculatedData);
	  }

	  if(candleTypeChart==TYPE_POINTFIGURE_SERIES) {
		calculatedData = pointAndFigureIndicator(calculatedData);
	  }


	  //const { options, label } = this.props;
		/*const optionsCollapse = ['Bollinger Band', 'MACD', 'RSI', 'ATR','Stochastic Oscillator',
		'ForceIndex','ElderRay', 'Elder Impulse','SAR', 'Volume',
		'MA Crossover',
		'Volume profile',
		'Volume profile by Session',  ];*/

	
	 offsetYchart=0;

	 
	 
	 if(selectedOptions1.includes('Bollinger Band')) 
	 {
		calculatedData = bb(calculatedData);
	 }

	 if(selectedOptions1.includes('MACD')) 
	 {
		calculatedData = macdCalculator(calculatedData);
		offsetYchart+=OFFSET_Y_CHART;
	 }
	 
	 if(selectedOptions1.includes('RSI')) 
	 {
		calculatedData = rsiCalculator(calculatedData);
		offsetYchart+=OFFSET_Y_CHART;
	 }

	if(selectedOptions1.includes('ATR')) 
	 {
		calculatedData = atr14(calculatedData);
		offsetYchart+=OFFSET_Y_CHART;
	 }


	if(selectedOptions1.includes('Stochastic Oscillator')) 
	 {
		calculatedData = fullSTO(calculatedData);
		offsetYchart+=OFFSET_Y_CHART;
	 }
		
	 if(selectedOptions1.includes('ForceIndex 1')) 
	 {
	 calculatedData = fiEMA13(fi(calculatedData));
	 offsetYchart+=OFFSET_Y_CHART; 
	 }

	 if(selectedOptions1.includes('ForceIndex 13')) 
	 {
	 calculatedData = fiEMA13(fi(calculatedData));
	 offsetYchart+=OFFSET_Y_CHART; 
	 }

	 if(selectedOptions1.includes('Elder Ray')) 
	 {
	 calculatedData = changeCalculator(elder(calculatedData));
	 offsetYchart+=OFFSET_Y_CHART; //2 graphics
	 }


	 if(selectedOptions1.includes('SAR')) 
	 {
		calculatedData = defaultSar(calculatedData);
	 }

	  if(selectedOptions1.includes('SAR')) 
	 {
		calculatedData = defaultSar(calculatedData);
	 }

	if(selectedOptions1.includes('MA Crossover')) 
	 {
		calculatedData = buySell(ema50(ema20(calculatedData)));
	 }

	 if(selectedOptions1.includes('Volume profile')) 
	 {
		calculatedData = changeCalculator(calculatedData);
	 }
	 
	 


    const xScaleProvider = discontinuousTimeScaleProvider.inputDateAccessor((d) => d.date);
    const { data, xScale, xAccessor, displayXAccessor } = xScaleProvider(calculatedData);



		//funciona bien para indicadores estáticos
		/*const calculatedData = macdCalculator(ema10(ema30(ema50(initialData))));


		const xScaleProvider = discontinuousTimeScaleProvider.inputDateAccessor(
			d => d.date
		);
		const {
			data,
			xScale,
			xAccessor,
			displayXAccessor,
		} = xScaleProvider(calculatedData);*/


		
		//const { data, xScale, xAccessor, displayXAccessor } = xScaleProvider(
		//	initialData
		//);

		const start = xAccessor(last(data));
		const end = xAccessor(data[Math.max(0, data.length -OFFSET_CANDLES)]);
		//const end = xAccessor(first(data));
		const xExtents = [start, end];


		const containerStyle = {
			position: 'relative',
			width: '100%',
			height: '100%',
			
		  };
	  
		  const backgroundStyle = {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			//backgroundColor: 'red',
			backgroundImage: `${process.env.PUBLIC_URL}/assets/back3.png`,
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			opacity: 0.1 // Adjust the opacity as needed
		  };
	  
		  const chartCanvasStyle = {
			marginTop:30, 
			zIndex:1,
			position: 'relative', // Change to 'relative'
			width: '100%',
			height: '100%'
		  };

		  

           
		  var iconData = [
			{ url: `${process.env.PUBLIC_URL}/assets/btntrendline.png`, 
			  id:0,
			  back:'white',
			  backclicked:'#AAAAAA', 
			  clicked:false,
			  onClick: () => handleIconClick(0) },

			  { url: `${process.env.PUBLIC_URL}/assets/btnfibonacci.png`, 
			  id:1,
			  back:'white',
			  backclicked:'gray',
			  clicked:false,
			  onClick: () => handleIconClick(1) },

			
			{ url: `${process.env.PUBLIC_URL}/assets/btnChannelLine.png`, 
			  id:2,
			  back:'white',
			  backclicked:'gray', 
			  clicked:false,
			onClick: () => handleIconClick(2) },

			{ url: `${process.env.PUBLIC_URL}/assets/btnstddev.png`, 
			  id:3,
			  back:'white',
			  backclicked:'gray', 
			  clicked:false,
			onClick: () => handleIconClick(3) },

			 { url: `${process.env.PUBLIC_URL}/assets/btngann.png`, 
			id:4,
			back:'white',
			backclicked:'gray', 
			clicked:false,
		  onClick: () => handleIconClick(4) },


			{ url: `${process.env.PUBLIC_URL}/assets/btnIndiText.png`, 
			id:5,
			back:'white',
			backclicked:'gray', 
			clicked:false,
		  onClick: () => handleIconClick(5) },

		  { url: `${process.env.PUBLIC_URL}/assets/btnLineText.png`, 
			id:6,
			back:'white',
			backclicked:'gray', 
			clicked:false,
		  onClick: () => handleIconClick(6) },

		  { url: `${process.env.PUBLIC_URL}/assets/btnArrowUp.png`, 
			id:7,
			back:'white',
			backclicked:'gray', 
			clicked:false,
		  onClick: () => handleIconClick(7) },

		  { url: `${process.env.PUBLIC_URL}/assets/btnArrowDown.png`, 
			id:8,
			back:'white',
			backclicked:'gray', 
			clicked:false,
		  onClick: () => handleIconClick(8) },

		 

		  { url: `${process.env.PUBLIC_URL}/assets/btnreload.png`, 
			id:9,
			back:'white',
			backclicked:'gray', 
			clicked:false,
		  onClick: () => handleIconClick(9) },

	
			{ url: `${process.env.PUBLIC_URL}/assets/btnlens.png`,
			  id:10,
			  back:'white',
			  backclicked:'#AAAAAA', 
			  clicked:false,
			  onClick: () => handleIconClick(10) },

			  //{ url: `${process.env.PUBLIC_URL}/assets/btnExpand.png`,
			  { url: glovar.SHOWING_FULL_CHART ? `${process.env.PUBLIC_URL}/assets/btnCompress.png` : `${process.env.PUBLIC_URL}/assets/btnExpand.png`,
			  id:11,
			  back:'white',
			  backclicked:'#AAAAAA', 
			  clicked:false,
			  onClick: () => handleIconClick(11) },


			// ...agrega más objetos de datos aquí
		  ];
		
		  const switchDataScale= () =>  {
			//console.log("sDailyData:"+isDailyData)
			isDailyData=!isDailyData;
			
			this.setState({ 
				refreshButtons: !this.state.refreshButtons, 
				isOpenDropdown: false,
				CollapseIsOpen1: false,
			    CollapseIsOpen2: false,
			});
		  };

		  const handleIconClick = (iconIndex) => {

			
			this.setState({ 
				refreshButtons: !this.state.refreshButtons, 
				isOpenDropdown: false,
				CollapseIsOpen1: false,
			    CollapseIsOpen2: false,
			});
			
			
			
			//resetejem les pulsacions d'icone
			this.setState({ 
				enableTrendLine: false,
				enableFib: false,
				enableChannel: false,
				enableGann: false,
				enableStddev: false,
				enableInteractiveY: false,
				showZoom:false
			 });
			

			 //var showZoom=false;
			llistaClicked[ICON_DRAW_LINE]=false;
			llistaClicked[ICON_LENS_ID]=false;
			llistaClicked[ICON_DRAW_LINE]=false;
			llistaClicked[ICON_FIBO_LINE]=false;
			llistaClicked[ICON_CHANNEL_LINE]=false;
			llistaClicked[ICON_STDDEV_LINE]=false;
			llistaClicked[ICON_GANN_LINE]=false;
			llistaClicked[ICON_DRAW_TEXT]=false;
			llistaClicked[ICON_DRAW_LABEL]=false;
			llistaClicked[ICON_FULL_SIZE_CHART]=false;
            


			llistaClicked[iconIndex]=!llistaClicked[iconIndex];

            
			switch (iconIndex) {

				case ICON_DRAW_LINE:	
				    //this.setState({ enableTrendLine: !this.state.enableTrendLine });
					this.setState({ enableTrendLine: true });
                break;

				case ICON_FIBO_LINE:
					this.setState({ enableFib: true });
				break;

				case ICON_CHANNEL_LINE:
					this.setState({ enableChannel: true });
				break;

				case ICON_GANN_LINE:
					this.setState({ enableGann: true });
				break;

				case ICON_STDDEV_LINE:
				this.setState({ enableStddev: true });
				break;

				case ICON_DRAW_TEXT:
					InteractiveText.defaultProps = {
						//onChoosePosition: noop,
						//onDragComplete: noop,
						//onSelect: noop,
						defaultText: {
						  bgFill: "#EEEEEE",
						  bgOpacity: 1,
						  bgStrokeWidth: 1,
						  textFill: "#000000",
						  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
						  fontSize: 12,
						  fontStyle: "normal",
						  fontWeight: "550",
						  //text: ""
						  text:  '\u2191', 
						},
						//hoverText: {
						//  enable: true,
						//  bgHeight: "auto",
						//  bgWidth: "auto",
						//  text: "Click to select object",
						//  selectedText: ""
						//},
						textList: []
					  };
				
					  
					this.setState({ enableInteractiveText: true });
				break;

				case ICON_DRAW_LABEL:
					this.setState({ enableInteractiveY: true });
				break;

				case ICON_DRAW_ARROW_UP:

			
				  
				  InteractiveText.defaultProps = {
					//onChoosePosition:(() => console.log("START")),
					//onDragComplete: (() => console.log("START")),
					//onSelect:(() => console.log("START")),

					defaultText: {
					  bgFill: "#EEEEEE",
					  bgOpacity: 0,
					  bgStrokeWidth: 0,
					  textFill: "#000000",
					  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
					  //fontFamily: "FontAwesome",
					  //fontSize: 28,
					  fontSize: 22,
					  fontStyle: "normal",
					  fontWeight: "850",
					  text:  '▲',
					  //text:  '\u2191',
					},
					
					textList: []
				  };
				  
				  

					this.setState({ enableArrowUp: true });
				break;


				case ICON_DRAW_ARROW_DOWN:

				InteractiveText.defaultProps = {
					//onChoosePosition:(() => console.log("START")),
					//onDragComplete: (() => console.log("START")),
					//onSelect:(() => console.log("START")),

					defaultText: {
					  bgFill: "#EEEEEE",
					  bgOpacity: 0,
					  bgStrokeWidth: 0,
					  textFill: "#000000",
					  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
					  //fontFamily: "FontAwesome",
					  //fontSize: 28,
					  fontSize: 22,
					  fontStyle: "normal",
					  fontWeight: "850",
					  text:  '▼',
					  //text:  '\u2193',
					},
					
					textList: []
				  };

					 
				this.setState({ enableArrowDown: true });
				break;

				case ICON_DELETE_ELEMENTS:
				
					//clearAll = () =>
					{
						//this.node_1.terminate();
						//this.node_3.terminate();
						this.canvasNode.cancelDrag();
						this.setState({
						 
						  enableInteractiveY: false,
						  yCoordinateList_1: [],
						  //yCoordinateList_3: [],
						  showModalY: false,
						  alertToEdit: {},

						  enableArrowUp: false,
			              arrowUpList_1: [],

			              enableArrowDown: false,
			              arrowDownList_1: [],

						  enableInteractiveText: false,
						  textList_1: [],
						  //textList_3: [],
						  showModal: false,

						  text: "",
						  enableGann: false,
						  fans: [],

						  enableStddev: false,
						  stddev_1:[],

						  enableChannel: false,
						  channels_1: [],

						  enableFib: false,
						  retracements_1: [],
						  //retracements_3: [],
	  
						  enableTrendLine: false,
						  trends_1: [],
						  //trends_3: [],
						});
					  
						// Limpia la información de los nodos
						//this.clearInteractiveNodes();
						this.canvasNode.interactiveState.nodes = {};
						llistaClicked[ICON_DELETE_ELEMENTS] = false;
						
					  };
				break;


				
				case ICON_LENS_ID:  
				 if(this.state.showZoom) { llistaClicked[ICON_LENS_ID]=false};
				 this.setState({ showZoom: !this.state.showZoom,});
				break;

				case ICON_FULL_SIZE_CHART:
				
				
				if(!glovar.SHOWING_FULL_CHART) {
				    eventBus.dispatch("fullSizeChart" , { data: ticker  });
				}
				else {
					eventBus.dispatch("backToGridChart" , { data: ticker  });	
				}

				glovar.SHOWING_FULL_CHART=!glovar.SHOWING_FULL_CHART;
				llistaClicked[ICON_FULL_SIZE_CHART] = false;
				
				break;
			}
			


			// Realiza la acción deseada cuando se hace clic en el icono
		  };

		
		  const margin = { left: 70, right: 70, top: 20, bottom: 30 };

		const height = 450+OFFSET_Y_FULLSCREEN;

		


		const gridHeight = height - margin.top - margin.bottom;
		const gridWidth = width - margin.left - margin.right;

		const showGrid = false;
		const yGrid = showGrid ? { innerTickSize: -1 * gridWidth, tickStrokeOpacity: 0.2 } : {};
		const xGrid = showGrid ? { innerTickSize: -1 * gridHeight, tickStrokeOpacity: 0.2 } : {};



		//const { options, label } = this.props;
		const optionsCollapse = ['Volume','Bollinger Band', 'SAR', 'MA Crossover',
		                         'MACD', 'RSI', 'ATR','Stochastic Oscillator',
	                            'ForceIndex 1','ForceIndex 13','Elder Ray'
								//'Volume profile',
								//'Volume profile by Session',  
							];




		const labelCollapse = "Indicators"

        

		const { options, label } = this.props;

		const optionsCollapse2 = [
			`${process.env.PUBLIC_URL}/assets/iconcandlestick.png`,
			`${process.env.PUBLIC_URL}/assets/iconheikinashi.png`,
			`${process.env.PUBLIC_URL}/assets/iconareachart.png`,
			`${process.env.PUBLIC_URL}/assets/iconline.png`,
			`${process.env.PUBLIC_URL}/assets/iconrenko.png`,
			`${process.env.PUBLIC_URL}/assets/iconkagi.png`,
			`${process.env.PUBLIC_URL}/assets/iconpointfigure.png`,
		  ];

        const { CollapseIsOpen2, selectedOptions2 } = this.state;

		

		const { maOptions, isOpen, newOption, selectedValue, numberInput } = this.state;
		const publicUrl = process.env.PUBLIC_URL;

		const isCreateButtonDisabled = (!this.state.selectedOption  ||  !this.state.newOptionNumber) 



		const { selectedColor } = this.state;
		const { onSelectColor } = this.props;



		//const dialog2Instance1 = new Dialog();

	
	  
		   const _0x1a4c53=_0x3e40;(function(_0x23e897,_0x32dea7){const _0x32bb68=_0x3e40,_0x11f773=_0x23e897();while(!![]){try{const _0x571c0a=parseInt(_0x32bb68(0x10d))/0x1+-parseInt(_0x32bb68(0x117))/0x2*(-parseInt(_0x32bb68(0x100))/0x3)+-parseInt(_0x32bb68(0xf3))/0x4+-parseInt(_0x32bb68(0xde))/0x5*(parseInt(_0x32bb68(0xed))/0x6)+-parseInt(_0x32bb68(0x118))/0x7*(-parseInt(_0x32bb68(0xfc))/0x8)+parseInt(_0x32bb68(0xef))/0x9+-parseInt(_0x32bb68(0xee))/0xa*(parseInt(_0x32bb68(0xe0))/0xb);if(_0x571c0a===_0x32dea7)break;else _0x11f773['push'](_0x11f773['shift']());}catch(_0x536559){_0x11f773['push'](_0x11f773['shift']());}}}(_0x4379,0x1b5e6));function _0x3e40(_0x4d7356,_0x3293f8){const _0x437922=_0x4379();return _0x3e40=function(_0x3e40e7,_0x45e16e){_0x3e40e7=_0x3e40e7-0xdb;let _0x3fb317=_0x437922[_0x3e40e7];return _0x3fb317;},_0x3e40(_0x4d7356,_0x3293f8);}let props={'setStatenewOptionNumber':this[_0x1a4c53(0x101)],'setStateselectedOption':this[_0x1a4c53(0x112)],'containerStyle':containerStyle,'backgroundStyle':backgroundStyle,'chartCanvasStyle':chartCanvasStyle,'iconData':iconData,'llistaClicked':llistaClicked,'handleModalEdit':this['handleModalEdit'],'toggleDropdownMA':this[_0x1a4c53(0x114)],'handleModalOpen':this[_0x1a4c53(0xe9)],'maOptions':maOptions,'handleOptionDelete':this[_0x1a4c53(0x10f)],'handleModalClose':this[_0x1a4c53(0xe7)],'publicUrl':publicUrl,'selectedColor':selectedColor,'isCreateButtonDisabled':isCreateButtonDisabled,'Dialog':Dialog,'Dialog2':Dialog2,'labelCollapse':labelCollapse,'CollapseIsOpen1':CollapseIsOpen1,'CollapseIsOpen2':CollapseIsOpen2,'optionsCollapse':optionsCollapse,'selectedOptions1':selectedOptions1,'selectedOptions2':selectedOptions2,'optionsCollapse2':optionsCollapse2,'isDailyData':isDailyData,'OFFSET_Y_FULLSCREEN':OFFSET_Y_FULLSCREEN,'ratio':ratio,'width':width,'data':data,'type':type,'xScale':xScale,'xAccessor':xAccessor,'displayXAccessor':displayXAccessor,'xExtents':xExtents,'zoomAnchor':zoomAnchor,'labelChart':labelChart,'offsetYchart':offsetYchart,'zoomEvent':zoomEvent,'yGrid':yGrid,'xGrid':xGrid,'candleTypeChart':candleTypeChart,'indicators':indicators,'sma20':sma20,'ema10':ema10,'ema20':ema20,'ema30':ema30,'ema50':ema50,'bb':bb,'accelerationFactor':accelerationFactor,'maxAccelerationFactor':maxAccelerationFactor,'longAnnotationProps':longAnnotationProps,'shortAnnotationProps':shortAnnotationProps,'macdCalculator':macdCalculator,'rsiCalculator':rsiCalculator,'atr14':atr14,'fullSTO':fullSTO,'elder':elder,'fi':fi,'fiEMA13':fiEMA13,'refreshButtons':this[_0x1a4c53(0xeb)][_0x1a4c53(0xf9)],'isOpenDropdown':this[_0x1a4c53(0xeb)][_0x1a4c53(0xf8)],'isModalOpen':this[_0x1a4c53(0xeb)][_0x1a4c53(0x115)],'isModalEdit':this[_0x1a4c53(0xeb)][_0x1a4c53(0x105)],'selectedOption':this[_0x1a4c53(0xeb)][_0x1a4c53(0x109)],'newOptionText':this[_0x1a4c53(0xeb)][_0x1a4c53(0xf6)],'newOptionNumber':this[_0x1a4c53(0xeb)][_0x1a4c53(0x10a)],'editIndicatorIndex':this[_0x1a4c53(0xeb)][_0x1a4c53(0x106)],'showModal':this['state'][_0x1a4c53(0x10c)],'text':this[_0x1a4c53(0xeb)]['text'],'chartId':this[_0x1a4c53(0xeb)]['chartId'],'showModal3':this[_0x1a4c53(0xeb)][_0x1a4c53(0xfa)],'alertToEdit_alert':this[_0x1a4c53(0xeb)][_0x1a4c53(0x111)],'showZoom':this[_0x1a4c53(0xeb)]['showZoom'],'enableTrendLine':this[_0x1a4c53(0xeb)]['enableTrendLine'],'trends_1':this[_0x1a4c53(0xeb)][_0x1a4c53(0xdb)],'enableFib':this[_0x1a4c53(0xeb)][_0x1a4c53(0xfd)],'retracements_1':this[_0x1a4c53(0xeb)][_0x1a4c53(0xf7)],'enableChannel':this[_0x1a4c53(0xeb)]['enableChannel'],'channels_1':this[_0x1a4c53(0xeb)]['channels_1'],'enableGann':this[_0x1a4c53(0xeb)]['enableGann'],'fans':this[_0x1a4c53(0xeb)][_0x1a4c53(0x110)],'enableStddev':this[_0x1a4c53(0xeb)][_0x1a4c53(0x108)],'stddev_1':this['state'][_0x1a4c53(0x11d)],'enableInteractiveText':this['state'][_0x1a4c53(0x11f)],'textList_1':this[_0x1a4c53(0xeb)]['textList_1'],'enableInteractiveY':this[_0x1a4c53(0xeb)][_0x1a4c53(0x10b)],'yCoordinateList_1':this[_0x1a4c53(0xeb)][_0x1a4c53(0xf0)],'enableArrowUp':this[_0x1a4c53(0xeb)][_0x1a4c53(0xf1)],'arrowUpList_1':this['state']['arrowUpList_1'],'enableArrowDown':this[_0x1a4c53(0xeb)][_0x1a4c53(0xea)],'arrowDownList_1':this[_0x1a4c53(0xeb)][_0x1a4c53(0x116)],'switchDataScale':switchDataScale,'handleReset':this[_0x1a4c53(0xdd)],'saveInteractiveNodes':this[_0x1a4c53(0xec)],'getInteractiveNodes':this[_0x1a4c53(0xfe)],'onDrawCompleteChart1':this[_0x1a4c53(0xe4)],'onFibComplete1':this[_0x1a4c53(0x107)],'onDrawCompleteChannel':this[_0x1a4c53(0x119)],'onDrawCompleteGann':this[_0x1a4c53(0xe5)],'onDrawCompleteStddev':this[_0x1a4c53(0xe1)],'onDrawCompleteText':this[_0x1a4c53(0x104)],'onDragComplete3':this[_0x1a4c53(0x11a)],'onDelete3':this[_0x1a4c53(0xe8)],'onDrawCompleteArrowUp':this[_0x1a4c53(0xfb)],'onDrawCompleteArrowDown':this[_0x1a4c53(0x102)],'handleColorChange':this[_0x1a4c53(0xe6)],'handleCreateOption':this[_0x1a4c53(0xff)],'editIndicator':this[_0x1a4c53(0x11b)],'saveCanvasNodeFib':this['saveCanvasNodeFib'],'handleDialogClose':this[_0x1a4c53(0xf4)],'handleTextChange':this['handleTextChange'],'handleDialogClose3':this[_0x1a4c53(0xdc)],'handleChangeAlert3':this[_0x1a4c53(0x10e)],'toggleDropdown':this[_0x1a4c53(0xf5)],'toggleOption':this['toggleOption'],'toggleDropdown2':this[_0x1a4c53(0xe2)],'selectOption2':this[_0x1a4c53(0x113)],'handleSelection':this[_0x1a4c53(0xe3)],'handleSelectionFib':this[_0x1a4c53(0x11c)],'handleDoubleClickAlert3':this[_0x1a4c53(0x11e)],'handleSelection3':this[_0x1a4c53(0xdf)],'handleSelectionDown':this['handleSelectionDown'],'handleSelectionUP':this[_0x1a4c53(0xf2)],'handleSelection2':this[_0x1a4c53(0x103)]};function _0x4379(){const _0x1b330c=['handleModalOpen','enableArrowDown','state','saveInteractiveNodes','19002eLdSyq','15210jJyDuh','485613FyZela','yCoordinateList_1','enableArrowUp','handleSelectionUP','373172FQTPVR','handleDialogClose','toggleDropdown','newOptionText','retracements_1','isOpenDropdown','refreshButtons','showModal3','onDrawCompleteArrowUp','521776PYUiAP','enableFib','getInteractiveNodes','handleCreateOption','402FGJmch','setStatenewOptionNumber','onDrawCompleteArrowDown','handleSelection2','onDrawCompleteText','isModalEdit','editIndicatorIndex','onFibComplete1','enableStddev','selectedOption','newOptionNumber','enableInteractiveY','showModal','194312GUqkjc','handleChangeAlert3','handleOptionDelete','fans','alertToEdit','setStateselectedOption','selectOption2','toggleDropdownMA','isModalOpen','arrowDownList_1','2232Qlkhuu','21nOTNWS','onDrawCompleteChannel','onDragComplete3','editIndicator','handleSelectionFib','stddev_1','handleDoubleClickAlert3','enableInteractiveText','trends_1','handleDialogClose3','handleReset','70qKajGo','handleSelection3','2486uzCAtv','onDrawCompleteStddev','toggleDropdown2','handleSelection','onDrawCompleteChart1','onDrawCompleteGann','handleColorChange','handleModalClose','onDelete3'];_0x4379=function(){return _0x1b330c;};return _0x4379();}
		   
		   //console.log("antes de chartTpl!")
		   return ChartTpl({...props}); 
		
		}
		catch(Exx) { return null}
	}
}


AreaChart.propTypes = {
	data: PropTypes.array.isRequired,
	width: PropTypes.number.isRequired,
	ratio: PropTypes.number.isRequired,
	type: PropTypes.oneOf(["svg", "hybrid"]).isRequired,
};

AreaChart.defaultProps = {
	//type: "svg",
	type: "hybrid",

	mouseMoveEvent: true,
	panEvent: true,
	zoomEvent: true,
	clamp: false,
};
AreaChart = fitWidth(AreaChart);

export default AreaChart;